import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceQrCheckPathParameters } from 'api/actions/device-qr-check/device-qr-check-path-parameters';
import { DeviceQrCheckResponse } from 'api/actions/device-qr-check/device-qr-check-response';

type DeviceQrCheckQueryParameters = Record<string, any>;

/**
 * The path of the DeviceQrCheck action.
 */
export const deviceQrCheckActionPath = new SweetPath<keyof DeviceQrCheckPathParameters>(
  '/api/device/qr/check/{deviceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeviceQrCheck actions.
 */
export default function createDeviceQrCheckAction(axios: AxiosInstance) {
  return function deviceQrCheckAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceQrCheckPathParameters;
    query?: DeviceQrCheckQueryParameters;
  }) {
    const path = deviceQrCheckActionPath.insert(parameters);

    return axios.request<DeviceQrCheckResponse, DeviceQrCheckResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
